import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  modalContainer: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
  },
  modal: {
    maxWidth: '562px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    margin: '0 20px',
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflow: 'auto',
  },
  modalTitleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  modalTitleAndIcon: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  modalBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    padding: '20px 0',
  },
  representativeInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  modalButtonsContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    gap: '10px',
  },
}));

export default useStyles;
